import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

const PARAM_NAME = 'payment'

/**
 * Чтение/запись `?payment=<tracking_uuid>` в query-параметре текущего URL.
 * Модалка статуса платежа показывается, пока этот параметр присутствует,
 * фон под ней — та страница, на которой пользователь начал платёж.
 */
export const usePaymentTrackingParam = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const trackingUuid = searchParams.get(PARAM_NAME)

  const setTrackingUuid = useCallback(
    (uuid: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev)
          next.set(PARAM_NAME, uuid)
          return next
        },
        { replace: false }
      )
    },
    [setSearchParams]
  )

  const clearTrackingUuid = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev)
        next.delete(PARAM_NAME)
        return next
      },
      { replace: true }
    )
  }, [setSearchParams])

  return { trackingUuid, setTrackingUuid, clearTrackingUuid }
}
